import { render, staticRenderFns } from "./WercbergerHotlineMessages.vue?vue&type=template&id=94c43a62&"
import script from "./WercbergerHotlineMessages.vue?vue&type=script&lang=js&"
export * from "./WercbergerHotlineMessages.vue?vue&type=script&lang=js&"
import style0 from "./WercbergerHotlineMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports